import { SelectOverrides } from 'baseui/select';
import { Icons, IconNames } from '@dapp/multi-lib/ui/icons';
import { iconSetProps } from './select-props.interface';

export const selectCustomOverrides = (
  externalOverrides: SelectOverrides,
  iconSet: iconSetProps
): SelectOverrides => {
  return {
    ...(externalOverrides || {}),
    Popover: {
      props: {
        overrides: {
          Body: {
            style: () => ({
              zIndex: 999,
            }),
          },
        },
      },
    },
    ControlContainer: {
      style: ({ $theme }) => ({
        borderBottomLeftRadius: $theme.borders?.radius300,
        borderBottomRightRadius: $theme.borders?.radius300,
        borderTopLeftRadius: $theme.borders?.radius300,
        borderTopRightRadius: $theme.borders?.radius300,
        backgroundColor: $theme.colors.backgroundTertiary,
        color: $theme.colors.white,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...((externalOverrides?.ControlContainer as any)?.style({ $theme }) ??
          {}),
      }),
    },
    Dropdown: {
      style: () => ({
        width: '100%',
      }),
    },
    DropdownListItem: {
      style: ({ $theme }) => ({
        ':hover': {
          textShadow: '0px 0px 16px #36BFFA, 0px 0px 8px #36BFFA',
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...((externalOverrides?.DropdownListItem as any)?.style({ $theme }) ??
          {}),
      }),
    },
    SelectArrow: {
      props: {
        overrides: {
          Svg: {
            component: () => (
              <Icons
                {...(iconSet?.fillColor && { fillColor: iconSet?.fillColor })}
                {...(iconSet?.iconWidth && { iconWidth: iconSet?.iconWidth })}
                {...(iconSet?.iconHeight && {
                  iconHeight: iconSet?.iconHeight,
                })}
                icon={iconSet?.icon as IconNames}
              />
            ),
          },
        },
      },
    },
  };
};
